import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectTopicsListItems, selectTopicsQueryItems } from '../../../../../../redux/chapter/topics/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import { topics } from '../../../../../../redux/chapter/topics/action';
import EventTicketsComponent from '../components/event-ticket.component';
import { selectEventTicketsQueryItems } from '../../../../../../redux/event/event-tickets/selector';
import { eventTickets } from '../../../../../../redux/event/event-tickets/action';
import { selectEventsListItems } from '../../../../../../redux/event/events/selector';

const ManagementEventTicket = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const parmas: any = useParams();
    const ticketsQuery = useSelector(selectEventTicketsQueryItems);
    const eventsListItems = useSelector(selectEventsListItems)
    const topicsItems = useSelector(selectTopicsListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [mediaFiles, setMediaFiles] = useState<any>([])
    const libraryData = useSelector(selectListItems)

    const [selectedEventTickets, setSelectedEventTickets] = useState<any>({
        "Name": "",
        "DisplayOrder": 0,
        "CommunityId": 0

    });

    const fetchForumGroupsQueryById = () => {
        dispatch(eventTickets.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/query`,
            entity: 'eventTickets',
            jsonData: {
                Context: {},
                Records: [
                    {

                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true);
        });
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedEventTickets({ ...selectedEventTickets, [field]: event });
    }
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }
    useEffect(() => {
        dispatch(topics.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics/list`,
            entity: 'topics',
            jsonData: {

            }
        })).then(() => {
            if (parmas?.id > 0) {
                fetchForumGroupsQueryById()
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }
        })
    }, []);

    useEffect(() => {
        if (isQuery) {
            setSelectedEventTickets(ticketsQuery?.result?.items);
        }
    }, [isQuery]);

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )

        const eventsTickets = {
            "Id": parmas.id || 0,
            "EventId": selectedEventTickets?.EventId || 0,
            "Name": selectedEventTickets?.Name || "",
            "Description": selectedEventTickets?.Description || "",
            "Price": Number(selectedEventTickets?.Price) || 0,
            "Currency": selectedEventTickets?.Currency || "",
            "QuantityAvailable": Number(selectedEventTickets?.QuantityAvailable) || 0,
            "QuantitySold": Number(selectedEventTickets?.QuantitySold) || 0,
            "Type": selectedEventTickets?.Type || "",
            "SaleStartDate": selectedEventTickets?.SaleStartDate || "",
            "IsFreeOfCost": selectedEventTickets?.IsFreeOfCost || false,
            "SaleEndDate": selectedEventTickets?.SaleEndDate || "",
            "OwnerType": "Event",
            "OwnerId": selectedEventTickets?.OwnerId,
            "Benefits": selectedEventTickets?.Benefits,
            "TermsAndConditions": selectedEventTickets?.TermsAndConditions,
            "MediaMappings": {
                "MediaFiles": [],
                "Templates": []
            }

        }
        if (parmas?.id > 0) {
            await dispatch(eventTickets.resetAction({ actionType: 'update' }))
            await dispatch(eventTickets.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets`,
                entity: 'eventTickets',
                jsonData: {
                    Context: {},
                    Records: [
                        eventsTickets
                    ]
                }
            })).then(() => {
                back();
            });
        } else {
            await dispatch(eventTickets.resetAction({ actionType: 'create' }))
            await dispatch(eventTickets.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets`,
                entity: 'eventTickets',
                jsonData: {
                    Context: {},
                    Records: [
                        eventsTickets
                    ]
                }
            })).then(() => {
                back();
            });
        }
    }

    const back = () => {
        navigate('/management/e-applications/event/event-tickets');
    }

    console.log(selectedEventTickets?.OwnerType, "parmas")
    return (
        <>
            {ticketsQuery?.isLoading ? <PageLoader /> :
                <EventTicketsComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedEventTickets={selectedEventTickets}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    topics={topicsItems?.result?.items}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                    libraryData={libraryData?.result?.ChapterTopicType}
                    events={eventsListItems?.result?.items}
                    EventType={libraryData?.result?.EventTicketType}

                />
            }
        </>
    );
}

export default ManagementEventTicket;
